import React, { Component } from "react";
import firebase from "firebase";
class SelfDelete extends Component {
  state = {
    email: "",
    inValid: false,
    isSuccess: false,
  };

  handleChange = (e) => {
    this.setState({ email: e.target.value });
  };

  handleClick = () => {
    if (localStorage.getItem("email") === this.state.email) {
      const db = firebase.firestore().collection("users").doc(this.state.email);
      db.get().then((doc) => {
        doc.ref.delete();
      });
      const user = firebase.auth().currentUser;
      user
        .delete()
        .then(function () {})
        .catch(function (error) {
          // An error happened.
        });
      this.setState({ isSuccess: true, inValid: false });
    } else {
      this.setState({ inValid: true });
    }
  };

  render() {
    return (
      <div
        style={{
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <input
          type="text"
          style={{
            width: "300px",
            height: "40px",
            borderRadius: "10px",
            padding: "10px",
            fontSize: "20px",
          }}
          onChange={this.handleChange}
        ></input>
        <button onClick={this.handleClick} style={{ marginTop: "20px" }}>
          delete
        </button>
        {this.state.inValid ? <div>Something went wrong!!!</div> : ""}
        {this.state.isSuccess ? <div>Deleted Successfully</div> : ""}
      </div>
    );
  }
}

export default SelfDelete;
